import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from './utils';

export const QueryRegistry = ({ children }: React.PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
